import ListActions from "../components/list_actions";
import { connect } from 'react-redux';

export default connect()(ListActions);
